import { useState, useCallback } from 'react';

export function getCurrentMonth(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

export function getPreviousMonth(month: string): string {
  const [year, monthNum] = month.split('-').map(Number);
  const prevDate = new Date(year, monthNum - 2);
  return `${prevDate.getFullYear()}-${String(prevDate.getMonth() + 1).padStart(2, '0')}`;
}

export function getNextMonth(month: string): string {
  const [year, monthNum] = month.split('-').map(Number);
  const nextDate = new Date(year, monthNum);
  return `${nextDate.getFullYear()}-${String(nextDate.getMonth() + 1).padStart(2, '0')}`;
}

export interface UseMonthNavigationOptions {
  initialMonth?: string;
}

export interface UseMonthNavigationReturn {
  currentMonth: string;
  setCurrentMonth: (month: string) => void;
  goToPrevMonth: () => void;
  goToNextMonth: () => void;
}

export function useMonthNavigation(
  options: UseMonthNavigationOptions = {}
): UseMonthNavigationReturn {
  const { initialMonth } = options;
  const [currentMonth, setCurrentMonth] = useState(
    () => initialMonth ?? getCurrentMonth()
  );

  const goToPrevMonth = useCallback(() => {
    setCurrentMonth((prev) => getPreviousMonth(prev));
  }, []);

  const goToNextMonth = useCallback(() => {
    setCurrentMonth((prev) => getNextMonth(prev));
  }, []);

  return {
    currentMonth,
    setCurrentMonth,
    goToPrevMonth,
    goToNextMonth,
  };
}
